import type {
  DeleteApplicationAttachmentMutation,
  DeleteApplicationAttachmentMutationVariables,
} from 'src/App/AppPageBlock/graphql/hirer-types.generated';
import graphqlClient from './client';
import gql from 'graphql-tag';

export const mutation = gql`
  mutation DeleteApplicationAttachment(
    $input: DeleteApplicationAttachmentInput!
  ) {
    deleteApplicationAttachment(input: $input) {
      success
    }
  }
`;

export const deleteApplicationAttachment = async (
  prospectId: string,
  attachmentId: string,
): Promise<boolean> => {
  const { data } = await graphqlClient.mutate<
    DeleteApplicationAttachmentMutation,
    DeleteApplicationAttachmentMutationVariables
  >({
    variables: {
      input: {
        prospectId,
        attachmentId,
      },
    },
    mutation,
  });

  return data?.deleteApplicationAttachment.success ?? false;
};
